import React from 'react';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Our Cyprus Adventure</h3>
            <p className="text-gray-300 mb-4">
              A personal travel blog documenting our wonderful family holiday at 
              Constantinou Bros Athena Beach Hotel in beautiful Paphos, Cyprus.
            </p>
            <div className="flex items-center gap-2 text-red-400">
              <Heart size={20} />
              <span>Made with love for our family memories</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-300 hover:text-white transition-colors">Home</a></li>
              <li><a href="#weather" className="text-gray-300 hover:text-white transition-colors">Weather</a></li>
              <li><a href="#programs" className="text-gray-300 hover:text-white transition-colors">Programs</a></li>
              <li><a href="#tours" className="text-gray-300 hover:text-white transition-colors">Tours</a></li>
              <li><a href="#review" className="text-gray-300 hover:text-white transition-colors">Review</a></li>
            </ul>
          </div>

          {/* Hotel Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Hotel Details</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center gap-2">
                <MapPin size={18} />
                <span>Constantinou Bros Athena Beach Hotel</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={18} />
                <span>Paphos, Cyprus</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={18} />
                <span>4 Star Resort</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={18} />
                <span>August 2-9, 2025</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            &copy; 2025 Cyprus Holiday Blog. This is a personal family travel blog documenting our vacation experience.
          </p>
          <p className="text-gray-500 mt-2 text-sm">
            All photos and experiences are from our actual stay at Constantinou Bros Athena Beach Hotel.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;